import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_HEADING_TEXT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_HEADING_TEXT_TYPE = 'postermywall-heading-text';

const HEADING_DATA_ATTR = 'data-is-pmw-form-header';

export const POSTERMYWALL_HEADING_TEXT: AddComponentTypeOptions = {
  extend: 'text',
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    if (!el.getAttribute(HEADING_DATA_ATTR)) {
      return undefined;
    }
    return {type: POSTERMYWALL_HEADING_TEXT_TYPE};
  },
  model: {
    defaults: {
      tagName: 'p',
      name: window.i18next.t('pmwjs_form_maker_name_heading'),
      icon: 'icon-text',
      stylable: true,
      highlightable: true,
      hoverable: true,
      selectable: true,
      editable: true,
      copyable: false,
      removable: false,
      badgable: true,
      draggable: false,
      toolbar: [],
      content: 'Subscribe to our newsletter',
      attributes: {
        'data-pmw-type': POSTERMYWALL_HEADING_TEXT_TYPE,
        'data-is-pmw-form-header': '1',
      },
      style: FORM_HEADING_TEXT_STYLES,
    },
  },
};
